import React from "react";
import Icon from "components/AppIcon";

export default function MetricCard({ title, value, subtitle, icon, trend, trendLabel, accentColor = "var(--color-primary)" }) {
  return (
    <div className="card hover-lift cursor-default">
      <div className="flex items-start justify-between mb-3">
        <div
          className="flex items-center justify-center w-10 h-10 rounded-lg flex-shrink-0"
          style={{ background: `${accentColor}15` }}
        >
          <Icon name={icon} size={20} color={accentColor} strokeWidth={2} />
        </div>
        {trend !== undefined && (
          <span
            className="flex items-center gap-1 font-caption text-xs px-2 py-1 rounded-full"
            style={{
              background: trend >= 0 ? "rgba(5,150,105,0.1)" : "rgba(220,38,38,0.1)",
              color: trend >= 0 ? "var(--color-success)" : "var(--color-error)",
            }}
          >
            <Icon name={trend >= 0 ? "TrendingUp" : "TrendingDown"} size={12} />
            {trendLabel}
          </span>
        )}
      </div>
      <p className="font-data text-2xl md:text-3xl font-semibold text-foreground leading-tight">{value}</p>
      <p className="font-caption text-sm text-foreground font-medium mt-1">{title}</p>
      {subtitle && <p className="font-caption text-xs text-muted-foreground mt-0.5">{subtitle}</p>}
    </div>
  );
}